<form nz-form [formGroup]="purchaseFilterForm">
  <div nz-row [nzGutter]="16" style="display: flex; flex-wrap: wrap; align-items: flex-end; width: 100%;">

    <!-- Timeframe -->
    <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="3"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a Timeframe'">
          <nz-select formControlName="Timeframe" class="filters" id="Timeframe" nzPlaceHolder="Timeframe"
            nzShowSearch style="width: 100%;">
            @for(opt of loopback; track $index) {
              <nz-option [nzLabel]="'Last ' + opt.label" [nzValue]="opt.val"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <!-- Submission Date -->
    <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="3" [nzXl]="3" [nzXXl]="3"
      style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a Submission Date'">
          <ppl-date-picker formControlName="submissionDate" [id]="'submissionDate'" [showIcon]="true"
            [placeholder]="'Submission Date'" dateFormat="mm/dd/yy" [yearRange]="'1900:2050'" [iconDisplay]="'input'"
            inputId="submissionDateInput" [panelStyleClass]="'custom-calendar-panel'"
            style="width: 100%; display: block;">
          </ppl-date-picker>
        </nz-form-control>
      </nz-form-item>
    </div>

    <!-- Participant Name -->
    <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="3" [nzXl]="3" [nzXXl]="3"
      style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please enter Participant Name'">
          <input
            placeholder="Participant Name"
            nz-input
            formControlName="consumer"
            id="consumer" />
        </nz-form-control>
      </nz-form-item>
    </div>

    <!-- Participant PPL ID -->
    <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="3" [nzXl]="3" [nzXXl]="3"
      style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please enter Participant PPL ID'">
          <input
            placeholder="Participant PPL ID"
            nz-input
            formControlName="consumerPplId"
            id="consumerPplId" />
        </nz-form-control>
      </nz-form-item>
    </div>

    <!-- Service Code -->
    <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="5" [nzXXl]="5"
      style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a Service Code'">
          <nz-select
            formControlName="serviceCode"
            class="filters"
            id="serviceCode"
            nzPlaceHolder="Service Code"
            nzShowSearch
            nzAllowClear
            style="width: 100%;">
            @for (opt of serviceCodes; track $index) {
              <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <!-- PPL Purchase ID -->
    <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="3" [nzXl]="3" [nzXXl]="3"
      style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please enter PPL Purchase ID'">
          <input
            placeholder="PPL Purchase ID"
            nz-input
            formControlName="pplPurchaseId"
            id="pplPurchaseId" />
        </nz-form-control>
      </nz-form-item>
    </div>

    <!-- CRM Number filter — temporarily hidden, may be reintroduced later
    <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="3"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control>
          <input placeholder="CRM Number" nz-input
            formControlName="crmNumber" id="crmNumber" />
        </nz-form-control>
      </nz-form-item>
    </div>
    -->

    <!-- Search Button -->
    <div nz-col style="flex: none; width: auto; margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <ppl-button
          label="Search"
          icon="fa fa-filter"
          [styleString]="'margin-top: -2px;'"
          [customClass]="'ghost-button'"
          [iconPosition]="'left'"
          (click)="search()">
        </ppl-button>
      </nz-form-item>
    </div>

  </div>
</form>